import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Link, withRouter } from 'react-router-dom';
import styleable from 'react-styleable';
import defaultStyle from './tabs.style';

export class TabsComponent extends Component {
  render() {
    const { id, routes, location, title, css } = this.props;
    const { pathname } = location;
    const tabsId = id+'-tabs';
    const contentId = id+'-tab-content';

    // Screen reader notes:
    // For the tabs, title is intentionally set to a singular space.
    //
    // This causes the Jaws screen reader to omit reading the link address.
    // If there was actual text in the title, Jaws would read that too,
    // in this order:
    // title + data type + aria label
    // If title is omitted (or an empty string), Jaws will read the link address,
    // which is not desirable for the tabs we are showing here.
    // As a side note, the screen reader NVDA will only read the aria label,
    // so for the sake of broader screen reader compatibility the meaningful
    // label data is in the aria-label attribute.

    const tabs = routes.map((route, index) => {
      const descriptionId = id+'-'+index+'-description';
      return (
        <li key={route.url} className={pathname === route.url ? css.activeTab : css.inactiveTab} >
          <Link
            to={{pathname : route.url, state : { focusElement: contentId}}}
            role={css.tabRole}
            aria-selected={pathname === route.url}
            aria-posinset={index + 1}
            aria-setsize={routes.length}
            aria-label={route.label}
            aria-describedby={descriptionId}
            title={" "}>
            {route.label}{route.notificationIcon}
          </Link>
          <div id={descriptionId} className="skip">{route.description}</div>
        </li>
      );
    });

    const routeList = routes.map(route => (
      <Route key={route.path} {...route}/>
    ));


    return (
      <div id={id}>
        { title ? (
          <h1 className={css.header}>
            <span>
              {title}
            </span>
          </h1>
        ) : null}
        <div id={tabsId} className={css.tabs}>
          <ul className={css.tabList} role={css.tabListRole}>
            {tabs}
          </ul>
        </div>
        <div  tabIndex="-1" id={contentId} className="no-focus">
          <Switch>
            {routeList}
          </Switch>
        </div>
      </div>
    );
  }
}

TabsComponent.propTypes = {
  title: PropTypes.element,
  routes: PropTypes.array.isRequired,
};

export default styleable(defaultStyle) (withRouter(TabsComponent));
